function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0551 20.227C20.3365 18.9456 19.2977 15.8292 16.7349 13.2664C14.1721 10.7036 11.0557 9.66482 9.7743 10.9462C8.49289 12.2276 9.53167 15.344 12.0945 17.9068C14.6573 20.4696 17.7737 21.5084 19.0551 20.227Z",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25059 12.1251L1.11059 26.4013C0.949552 26.7496 0.899268 27.139 0.966523 27.5168C1.03378 27.8946 1.21533 28.2426 1.48668 28.514C1.75802 28.7853 2.10609 28.9669 2.48388 29.0341C2.86168 29.1014 3.25102 29.0511 3.59934 28.8901L17.8756 20.7563",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7178 9.62506C19.7614 9.6686 19.7961 9.72033 19.8197 9.77728C19.8433 9.83423 19.8555 9.89528 19.8555 9.95694C19.8555 10.0186 19.8433 10.0796 19.8197 10.1366C19.7961 10.1935 19.7614 10.2453 19.7178 10.2888",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0537 9.625C19.1416 9.53722 19.2607 9.48792 19.385 9.48792C19.5092 9.48792 19.6283 9.53722 19.7162 9.625",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0517 10.2837C18.9642 10.1954 18.915 10.0761 18.915 9.95181C18.915 9.82749 18.9642 9.7082 19.0517 9.61993",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7162 10.2838C19.6283 10.3715 19.5092 10.4208 19.385 10.4208C19.2607 10.4208 19.1416 10.3715 19.0537 10.2838",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0195 4.3175C25.0631 4.36094 25.0978 4.41256 25.1214 4.46941C25.145 4.52625 25.1571 4.5872 25.1571 4.64875C25.1571 4.71031 25.145 4.77126 25.1214 4.8281C25.0978 4.88495 25.0631 4.93657 25.0195 4.98",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3574 4.31754C24.4009 4.27392 24.4525 4.23932 24.5093 4.2157C24.5662 4.19209 24.6271 4.17993 24.6887 4.17993C24.7502 4.17993 24.8112 4.19209 24.868 4.2157C24.9249 4.23932 24.9765 4.27392 25.0199 4.31754",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3564 4.98C24.3127 4.93657 24.2781 4.88495 24.2545 4.8281C24.2309 4.77126 24.2187 4.71031 24.2188 4.64875C24.2187 4.5872 24.2309 4.52625 24.2545 4.46941C24.2781 4.41256 24.3127 4.36094 24.3564 4.3175",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0199 4.97998C24.932 5.06776 24.8129 5.11707 24.6887 5.11707C24.5645 5.11707 24.4453 5.06776 24.3574 4.97998",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0195 17.575C25.0632 17.6186 25.0978 17.6703 25.1214 17.7272C25.1451 17.7842 25.1572 17.8452 25.1572 17.9069C25.1572 17.9685 25.1451 18.0296 25.1214 18.0865C25.0978 18.1435 25.0632 18.1952 25.0195 18.2388",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3574 17.575C24.4453 17.4872 24.5645 17.4379 24.6887 17.4379C24.8129 17.4379 24.932 17.4872 25.0199 17.575",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3565 18.2388C24.3128 18.1952 24.2782 18.1435 24.2545 18.0865C24.2309 18.0296 24.2187 17.9685 24.2188 17.9069C24.2187 17.8452 24.2309 17.7842 24.2545 17.7272C24.2782 17.6703 24.3128 17.6186 24.3565 17.575",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0199 18.2387C24.932 18.3265 24.8129 18.3758 24.6887 18.3758C24.5645 18.3758 24.4453 18.3265 24.3574 18.2387",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4365 5.64252C10.5241 5.73078 10.5732 5.85007 10.5732 5.97439C10.5732 6.09872 10.5241 6.218 10.4365 6.30627",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M9.77246 5.64252C9.86035 5.55474 9.97949 5.50543 10.1037 5.50543C10.2279 5.50543 10.3471 5.55474 10.435 5.64252",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M9.77345 6.30627C9.7298 6.26272 9.69517 6.211 9.67154 6.15405C9.64791 6.0971 9.63574 6.03605 9.63574 5.97439C9.63574 5.91274 9.64791 5.85168 9.67154 5.79474C9.69517 5.73779 9.7298 5.68606 9.77345 5.64252",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M10.435 6.30621C10.3471 6.39399 10.2279 6.4433 10.1037 6.4433C9.97949 6.4433 9.86035 6.39399 9.77246 6.30621",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M16.072 0.9375C16.3358 3.2999 16.1099 5.69133 15.4082 7.9625",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7104 2.66003L20.0479 5.97378",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M29.0631 13.9288C26.7007 13.6649 24.3093 13.8909 22.0381 14.5925",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3391 9.28882L24.0254 9.95132",
  stroke: "white",
  strokeWidth: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.7b58f5a8.svg";
export { ForwardRef as ReactComponent };